import { Pipe, PipeTransform } from '@angular/core';

import { Memoize } from '@libs/src/functions/memoize';

import truncate from 'lodash-es/truncate';

@Pipe({ name: 'truncateString' })
export class TruncateStringPipe implements PipeTransform {
  @Memoize()
  transform(value: string, limit = 30): string {
    return value?.length > limit
      ? `${truncate(value, { length: limit })}`
      : value;
  }
}
